import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import "./index.scss";
import Formula3DPreview from "../../../FormulaGenerator/Formula3DPreview";
import singleJawApparateIcon from "./images/singleJawApparate.png";
import doubleJawApparateIcon from "./images/doubleJawApparate.png";
import { singleJawApparate, doubleJawApparate } from "./orthoTypes";
import SelectionTypeList from "../../SelectionTypeList";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const OrthoChildTreatment = ({
  stepId,
  stepInfoPrefix,
  setNextKeyPrefix,
  currentChoice,
  toggleNextBtnState
}) => {
  const {
    _t
  } = useTranslation();
  const {
    dentalData,
    setStepFormula
  } = useContext(StepContext);
  const availableTypes = useMemo(() => {
    return [{
      key: "singleJawApparate",
      img: singleJawApparateIcon,
      name: _t("Одночелюстные аппараты")
    }, {
      key: "doubleJawApparate",
      img: doubleJawApparateIcon,
      name: _t("Двухчелюстные аппараты")
    }];
  }, [_t]);
  const runOnce = useRef(false);
  useEffect(() => {
    if (!runOnce.current) {
      if (!currentChoice || !currentChoice.hasOwnProperty("formula") || !currentChoice.formula.hasOwnProperty("prosthesis") || !currentChoice.formula.prosthesis.length) {
        toggleNextBtnState(true);
        runOnce.current = true;
      }
    }
  }, [currentChoice, setNextKeyPrefix, toggleNextBtnState]);
  useEffect(() => {
    if (!stepInfoPrefix && currentChoice.hasOwnProperty("formula") && currentChoice.formula.hasOwnProperty("prosthesis") && currentChoice.formula.prosthesis.length) {
      toggleNextBtnState(true);
      setStepFormula(stepId, { ...dentalData,
        prosthesis: []
      });
    }
  }, [currentChoice, dentalData, setNextKeyPrefix, stepId, stepInfoPrefix, toggleNextBtnState]);
  const [isFormulaLoaded, setIsFormulaLoaded] = useState(false);

  function formulaLoadedCallback() {
    setIsFormulaLoaded(true);
  }

  const [selected, setSelected] = useState("");

  function setData(key) {
    if (!isFormulaLoaded) {
      return;
    }

    setSelected(key);
    let updatedData = {};

    switch (key) {
      case "singleJawApparate":
        updatedData = singleJawApparate;
        break;

      case "doubleJawApparate":
        updatedData = doubleJawApparate;
        break;

      default:
        break;
    }

    setStepFormula(stepId, updatedData);
    setNextKeyPrefix(key);
    toggleNextBtnState(false);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "orthoChildTreatment"
  }, /*#__PURE__*/React.createElement("div", {
    className: "orthoChildTreatment-types"
  }, /*#__PURE__*/React.createElement("p", null, _t("Выберите ниже")), /*#__PURE__*/React.createElement(SelectionTypeList, {
    types: availableTypes,
    selected: selected,
    setData: setData,
    columns: 1,
    disable: !isFormulaLoaded
  })), /*#__PURE__*/React.createElement("div", {
    className: "orthoChildTreatment-container"
  }, /*#__PURE__*/React.createElement(Formula3DPreview, {
    stlPack: dentalData,
    availableSwitchers: ["top", "bottom", "base", "orthoSystems"],
    hideNotUsedSides: false,
    onLoaded: formulaLoadedCallback
  })));
};

export default OrthoChildTreatment;